import { render, staticRenderFns } from "./textFooter_Search_html.vue?vue&type=template&id=1992e1df&scoped=true"
import script from "./textFooter_Search_html.vue?vue&type=script&lang=js"
export * from "./textFooter_Search_html.vue?vue&type=script&lang=js"
import style0 from "./textFooter_Search_html.vue?vue&type=style&index=0&id=1992e1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992e1df",
  null
  
)

export default component.exports